<template>
  <div class="integration-section">
    <div class="sac__font-20 semi-bold grid-column ai-c jc-s gap-10">
      Opportunities & Service Requests
    </div>
    <div v-if="loadingSettings">
      <img src="@shared/assets/img/general/loading.svg" alt="loading" />
    </div>
    <div v-else>
      <div>
        <div class="mt-4">
          <div>
            <div class="sac__font-16 semi-bold">Service Requests</div>
            <div class="sac__font-16">
              Handles a customer's requests for assistance or specific services.
            </div>
          </div>
          <div class="grid-column ai-c jc-s gap-10 mt-4">
            <SACToggleSwitch :checked="isRequestToggleOn" :change="toggleRequestSetting" />
            <div class="sac__font-14">
              Enable or Disable Service Requests from SmartAC syncing to ServiceTitan.
            </div>
          </div>
          <div class="mt-2 ml-10" v-if="isRequestToggleOn">
            <div class="grid-row ai-c jc-s gap-16">
              <SACRadio
                :checked="serviceRequestSetting === 'job'"
                :change="() => saveRequestSetting('job')"
                label="Real Time Scheduling"
                sub-label="Members can book their own service appointments through the SmartAC.com app during your available business hours. These Service Requests will be recorded in ServiceTitan as Jobs."
              />
              <div
                v-if="serviceRequestSetting === 'job'"
                class="grid-column ai-s jc-s gap-10 info-border"
              >
                <div class="icon-luc-CircleAlert sac__font-18 tomato med" />
                <div class="sac__font-14 n60">
                  Emergency Service Requests or Service Requests with missing information will be
                  recorded as a Booking.
                </div>
              </div>
              <SACRadio
                :checked="serviceRequestSetting === 'booking'"
                :change="() => saveRequestSetting('booking')"
                label="Track as a Booking"
                sub-label="Service Requests will be tracked in Service Titan as a Booking."
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div class="sac__font-16 semi-bold mt-4">Opportunities</div>
          <div class="sac__font-16">Performance alerts that can generate a job.</div>
        </div>
        <div class="mt-2">
          <div class="grid-column ai-s jc-s gap-16">
            <SACToggleSwitch
              :checked="leadSetting === 'booking'"
              :change="() => saveLeadSetting('booking')"
              class="mt-1"
            />
            <div>
              <div class="sac__font-14 med">Track as a Booking.</div>
              <div class="sac__font-14">
                Enable or Disable SmartAC Opportunities syncing to ServiceTitan Bookings.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SACToggleSwitch from '@shared/components/sac/SACToggleSwitch.vue';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import { mapGetters, mapState } from 'vuex';
import SACTooltipItem from '@shared/components/sac/SACTooltip.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';

export default {
  name: 'ScheduleSetting',
  components: { SACCheckbox, SACTooltipItem, SACRadio, SACToggleSwitch },
  computed: {
    ...mapState({
      setting: (state) => state.setting.partnerSettings,
      loadingSettings: (state) => state.setting.loadingSettings,
      partnerSetting: (state) => state.partnerDetail.partnerSettings,
    }),
    ...mapGetters(['isSmacAdmin']),
    partnerSettings() {
      if (this.isSmacAdmin) {
        return this.partnerSetting;
      }
      return this.setting;
    },
  },
  data() {
    return {
      isRequestToggleOn: false,
      serviceRequestSetting: '',
      leadSetting: '',
    };
  },
  watch: {
    partnerSettings: {
      immediate: true,
      deep: true,
      handler() {
        this.setupInitValue();
      },
    },
  },
  methods: {
    saveRequestSetting(value) {
      this.serviceRequestSetting = value;
      this.saveSetting('ST_SR_DISPATCH_TYPE', value);
    },
    toggleRequestSetting() {
      this.isRequestToggleOn = !this.isRequestToggleOn;
      if (!this.isRequestToggleOn) {
        this.saveSetting('ST_SR_DISPATCH_TYPE', '');
      }
    },
    saveLeadSetting(value) {
      let v = value;
      if (value === this.leadSetting) {
        v = '';
      }
      this.leadSetting = v;
      this.saveSetting('ST_LEAD_DISPATCH_TYPE', v);
    },
    saveSetting(name, value) {
      const payload = [
        {
          settingName: name,
          settingValue: value,
        },
      ];
      this.$store.dispatch('setPartnerSetting', payload);
    },
    setupInitValue() {
      if (!!this.partnerSettings?.ST_SR_DISPATCH_TYPE) {
        this.serviceRequestSetting = this.partnerSettings.ST_SR_DISPATCH_TYPE;
        this.isRequestToggleOn = true;
      } else {
        this.isRequestToggleOn = false;
      }
      if (!!this.partnerSettings?.ST_LEAD_DISPATCH_TYPE) {
        this.leadSetting = this.partnerSettings.ST_LEAD_DISPATCH_TYPE;
      }
    },
  },
  mounted() {
    this.setupInitValue();
  },
};
</script>

<style lang="scss" scoped>
.info-border {
  padding: 12px;
  border: 1px solid $N20;
  border-radius: 4px;
}
</style>
